module.exports = __webpack_public_path__ + "static/media/icon_aam_inactive.37930bc6.svg";